/** Default configuration */
export const DEFAULT_TOAST_CONFIG = {
    maxVisible: 3,
    defaultAutoHideDuration: 10000,
    groups: {
        // Priority: 0 = top of stack, higher numbers = lower in stack
        // Superuser alerts are most critical - always show at top
        superuser: { maxStack: 1, priority: 0, template: 'superuser', persist: true },
        // Locates are high priority - show near top
        locates: { maxStack: 1, priority: 1 },
        // Default messages
        default: { maxStack: 1, priority: 2 },
        // Alerts must persist until manually dismissed - no stack limit
        alerts: { maxStack: Infinity, priority: 3, persist: true },
    },
};
/** Default group config for unknown groups */
export const DEFAULT_GROUP_CONFIG = {
    maxStack: 1,
    priority: 99,
};
/** Initial toast state */
export const initialToastState = {
    messages: {},
    groupQueues: {},
    config: DEFAULT_TOAST_CONFIG,
};
//# sourceMappingURL=toast.js.map